export type TThronAssetType = 'image' | 'video';

export interface IThronAsset {
	id: string;
	type: TThronAssetType;
}

/**
 * Parses a c_thronAssetsIds string array ("contentId:type") into typed assets.
 * Shared by AbstractProductModel and ProductSearchHitModel.
 */
export function parseThronAssetsIds(raw: string[] | undefined): IThronAsset[] {
	return (raw || [])
		.map((entry) => {
			const lastColonIndex = entry.lastIndexOf(':');

			if (lastColonIndex === -1) {
				return null;
			}

			const id = entry.substring(0, lastColonIndex).trim();
			const type = entry.substring(lastColonIndex + 1).trim() as TThronAssetType;

			if (!id || (type !== 'image' && type !== 'video')) {
				return null;
			}

			return {id, type};
		})
		.filter(Boolean) as IThronAsset[];
}
